import _ from 'lodash';

function shuffleActivePetType(collectedPets) {
	if (_.isUndefined(collectedPets) || _.isEmpty(collectedPets)) {
		return null;
	}

	const randomPet = collectedPets[_.random(collectedPets.length - 1)];

	return randomPet;
}

export default shuffleActivePetType;



// WEBPACK FOOTER //
// ./src/utils/shuffleActivePetType.js